// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IChannelDto } from './IChannelDto';
import {
    IChannelDtoFromJSON,
    IChannelDtoFromJSONTyped,
    IChannelDtoToJSON,
    IChannelDtoToJSONTyped,
} from './IChannelDto';

/**
 * 
 * @export
 * @interface IInitiateAuthResponseDto
 */
export interface IInitiateAuthResponseDto {
    /**
     * 
     * @type {string}
     * @memberof IInitiateAuthResponseDto
     */
    access_token?: string;
    /**
     * 
     * @type {string}
     * @memberof IInitiateAuthResponseDto
     */
    refresh_token?: string;
    /**
     * 
     * @type {number}
     * @memberof IInitiateAuthResponseDto
     */
    expires_in?: number;
    /**
     * 
     * @type {Array<IChannelDto>}
     * @memberof IInitiateAuthResponseDto
     */
    channels?: Array<IChannelDto>;
    /**
     * 
     * @type {string}
     * @memberof IInitiateAuthResponseDto
     */
    session?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IInitiateAuthResponseDto
     */
    required_express_setup?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IInitiateAuthResponseDto
     */
    remember_me_device_token?: string;
}

/**
 * Check if a given object implements the IInitiateAuthResponseDto interface.
 */
export function instanceOfIInitiateAuthResponseDto(value: object): value is IInitiateAuthResponseDto {
    return true;
}

export function IInitiateAuthResponseDtoFromJSON(json: any): IInitiateAuthResponseDto {
    return IInitiateAuthResponseDtoFromJSONTyped(json, false);
}

export function IInitiateAuthResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IInitiateAuthResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'access_token': json['access_token'] == null ? undefined : json['access_token'],
        'refresh_token': json['refresh_token'] == null ? undefined : json['refresh_token'],
        'expires_in': json['expires_in'] == null ? undefined : json['expires_in'],
        'channels': json['channels'] == null ? undefined : ((json['channels'] as Array<any>).map(IChannelDtoFromJSON)),
        'session': json['session'] == null ? undefined : json['session'],
        'required_express_setup': json['required_express_setup'] == null ? undefined : json['required_express_setup'],
        'remember_me_device_token': json['remember_me_device_token'] == null ? undefined : json['remember_me_device_token'],
    };
}

export function IInitiateAuthResponseDtoToJSON(json: any): IInitiateAuthResponseDto {
    return IInitiateAuthResponseDtoToJSONTyped(json, false);
}

export function IInitiateAuthResponseDtoToJSONTyped(value?: IInitiateAuthResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'access_token': value['access_token'],
        'refresh_token': value['refresh_token'],
        'expires_in': value['expires_in'],
        'channels': value['channels'] == null ? undefined : ((value['channels'] as Array<any>).map(IChannelDtoToJSON)),
        'session': value['session'],
        'required_express_setup': value['required_express_setup'],
        'remember_me_device_token': value['remember_me_device_token'],
    };
}

